import { FormattedMessage } from 'react-intl';
import { getListMenuTrackingAttributes } from '../../../tracking/clickTracking';

interface Props {
    chapter: string;
    activeChapter: string;
    // biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience for migration to biomejs
    onClick: (event: any) => void;
}

export const InfoDialogMenuItem = ({ chapter, activeChapter, onClick }: Props) => (
    // biome-ignore lint/a11y/noStaticElementInteractions: suppress out of convenience for migration to biomejs
    <span
        className={activeChapter === chapter ? 'active' : undefined}
        onClick={onClick}
        data-name={chapter}
        {...getListMenuTrackingAttributes(chapter)}
    >
        <FormattedMessage id={`intl-msg:${chapter}`} />
    </span>
);
